import { parseThemeColor } from "./auth-service-tools206.js";
import "react";
import "./auth-service-tools177.js";

function colorResolver(color, theme) {
  const parsedColor = parseThemeColor({
    color,
    theme
  });

  if (parsedColor.color === "dimmed") {
    return "var(--mantine-color-dimmed)";
  }

  if (parsedColor.color === "bright") {
    return "var(--mantine-color-bright)";
  }

  return parsedColor.variable ? `var(${parsedColor.variable})` : parsedColor.color;
}

function textColorResolver(color, theme) {
  const parsedColor = parseThemeColor({
    color,
    theme
  });

  if (parsedColor.isThemeColor && parsedColor.shade === void 0) {
    return `var(--mantine-color-${parsedColor.color}-text)`;
  }

  return colorResolver(color, theme);
}

export { colorResolver, textColorResolver };